module.exports = __webpack_public_path__ + "assets/img/404.9eb0f559.png";